module.exports = __webpack_public_path__ + "assets/img/4.d815d599.png";